import { render, staticRenderFns } from "./InputDefault.vue?vue&type=template&id=a4fb398e&"
import script from "./InputDefault.vue?vue&type=script&lang=ts&"
export * from "./InputDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports